export const FETCH_POSTS = 'GET_POSTS';
